<template>
  <div class="c-thum">
    <div class="c-thum-row" v-for="(item,index) in items">
      <div class="c-thum-item" :class="(index+1) % 2 === 0 ? 'even' : 'odd'"
           @click="itemClick(item)">
        <img :src="item.img">
        <slot name="item" :obj="item"></slot>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-thum',
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {
      itemClick (itemObj) {
        this.$emit('click', itemObj)
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?1aa7edb8